import { StrictMode } from "react";
import { mount } from "@/lib/mount";
import "@/index.css";
import { App } from "./App";

mount(
  <StrictMode>
    <App />
  </StrictMode>
);
